type CommissionReader = {
  id: string;
  is_admin: boolean;
  teams: ReadonlyArray<{ team_id: string; is_leader: boolean }>;
};

type CommissionTransaction = {
  seller_broker_id?: string | null;
  buyer_broker_id?: string | null;
  created_by?: string | null;
  seller_broker_team_id?: string | null;
  buyer_broker_team_id?: string | null;
  mls_share?: { team_id: string } | null;
};

// Mirrors the agent read rule of hasura-crm public_commissions.yaml: other team
// members get no commission rows, so showing them the tab would only mislead.
// Admins run as tenant_admin, which reads every commission of the tenant.
export const canReadCommissions = (
  me: CommissionReader,
  transaction: CommissionTransaction,
): boolean =>
  me.is_admin ||
  [
    transaction.seller_broker_id,
    transaction.buyer_broker_id,
    transaction.created_by,
  ].includes(me.id) ||
  me.teams.some(
    ({ team_id, is_leader }) =>
      team_id === transaction.mls_share?.team_id ||
      (is_leader &&
        (team_id === transaction.seller_broker_team_id ||
          team_id === transaction.buyer_broker_team_id)),
  );
